/* global $: true */

(() => {
  angular
    .module('gm.common.controllers')
    .controller('MainAppNavController', MainAppNavController);

  function MainAppNavController(
    $scope,
    $document,
    $rootScope,
    GmySlideNavigation,
    GmyFeatures
  ) {
    'ngInject';

    GmyFeatures.checkEnabledAndCountry('sendPayment')
      .then((enabled) => { $scope.sendPaymentEnabled = enabled; });

    GmyFeatures.checkEnabledAndCountry('sendInvoice')
      .then((enabled) => { $scope.sendInvoiceEnabled = enabled; });

    $document.on('click', (event) => {
      if ($rootScope.mainAppNavOpen) {
        $rootScope.mainAppNavOpen = false;
        event.preventDefault();
      }
    });

    $document.on('keyup', (event) => {
      const target = $(event.target);
      const isInput = target.is('input') || target.is('textarea') || target.is('select');

      if (event.which === 78 && !isInput) {
        // 'n' keypress not on an input
        $scope.$apply(() => {
          $document.scrollTop(0);
          GmySlideNavigation.open();
          event.stopPropagation();
        });
      } else if (event.which === 27 && GmySlideNavigation.isOpen()) {
        // 'esc' keypress
        $scope.$apply(() => {
          GmySlideNavigation.close();
          $rootScope.appMoreNav = false;
          event.stopPropagation();
        });
      }
    });

    $scope.openMoreNav = (event) => {
      $rootScope.appMoreNav = true;
      event.stopPropagation();
    };

    $scope.$on('$locationChangeSuccess', () => {
      $rootScope.appMoreNav = false;
    });
  }
})();
